import { createContext, useContext, useState, useEffect } from 'react';

// 모드 전역 상태
// mode: 'normal' | 'special' | 'excel'
// - normal: 기본 다크 모드
// - special: 영문 데이터 분석 보고서 스킨
// - excel: 엑셀 스프레드시트 스킨 (완전 추상화)
//
// 단축키: Ctrl+B → normal ↔ special 토글
//         Ctrl+Shift+B → excel 모드 진입/해제

const DisguiseContext = createContext({
  mode: 'normal',
  disguised: false,   // special 또는 excel일 때 true (하위 호환)
  excel: false,       // excel 모드 전용
  setMode: () => {},
  toggleDisguise: () => {},
});

export function DisguiseProvider({ children }) {
  const [mode, setMode] = useState('normal');

  const disguised = mode !== 'normal';  // 하위 호환
  const excel     = mode === 'excel';

  const toggleDisguise = () => {
    setMode(m => m === 'normal' ? 'special' : 'normal');
  };

  // Ctrl+B: normal ↔ special 토글
  // Ctrl+Shift+B: excel 모드 진입/해제
  useEffect(() => {
    const handler = (e) => {
      const tag = e.target?.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA') return;

      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'b') {
        e.preventDefault();
        if (e.shiftKey) {
          // Ctrl+Shift+B: excel 토글
          setMode(m => m === 'excel' ? 'normal' : 'excel');
        } else {
          // Ctrl+B: normal ↔ special 토글
          setMode(m => m === 'normal' ? 'special' : 'normal');
        }
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, []);

  // 모드별 브라우저 탭 제목
  useEffect(() => {
    if (mode === 'excel')   document.title = '분기별 데이터 현황.xlsx - Excel';
    else if (mode === 'special') document.title = 'Q3 Data Analysis';
    else                    document.title = 'StockTool 주식도구';
  }, [mode]);

  return (
    <DisguiseContext.Provider value={{ mode, disguised, excel, setMode, toggleDisguise }}>
      {children}
    </DisguiseContext.Provider>
  );
}

export function useDisguise() {
  return useContext(DisguiseContext);
}
